import { render, staticRenderFns } from "./TableNotes.vue?vue&type=template&id=c1e9d6f4&scoped=true"
import script from "./TableNotes.js?vue&type=script&lang=js&external"
export * from "./TableNotes.js?vue&type=script&lang=js&external"
import style0 from "./TableNotes.vue?vue&type=style&index=0&id=c1e9d6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e9d6f4",
  null
  
)

export default component.exports